import { useEffect, useState } from "react";
export function useCountdown(initialSeconds: number) {
  const [remaining, setRemaining] = useState(initialSeconds);
  useEffect(() => {
    const end = Date.now() + initialSeconds * 1000;
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, Math.round((end - Date.now()) / 1000)));
    }, 1000);
    return () => window.clearInterval(id);
  }, [initialSeconds]);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  return { hours, minutes, seconds };
}
